import { createFileRoute } from '@tanstack/react-router'

import {
  LevelAccessGuard,
  LevelPlayPage,
  LevelProvider
} from '@/features/level-play'

export const Route = createFileRoute('/_authenticated/niveis/$levelUid')({
  component: LevelPlayRoute
})

function LevelPlayRoute() {
  const { levelUid } = Route.useParams()

  return (
    <LevelAccessGuard levelUid={levelUid}>
      <LevelProvider levelUid={levelUid}>
        <LevelPlayPage />
      </LevelProvider>
    </LevelAccessGuard>
  )
}
